

import React, { memo } from 'react';

import ContentLoader from 'react-content-loader';
import { FLATTENED_COLOURS, COLOURS } from '../../../common/styles/vars';

const colorMap = {
  darkTheme: {
    primaryColor: COLOURS.grey.nevada,
    secondaryColor: COLOURS.grey.raspingSandy
  },
  lightTheme: {
    primaryColor: COLOURS.grey.athens.parthenon,
    secondaryColor: COLOURS.grey.sterling
  }
};













function getTheme(customTheme, { darkTheme }) {
  if (customTheme) {
    return {
      primaryColor: FLATTENED_COLOURS[customTheme.primaryColor],
      secondaryColor: FLATTENED_COLOURS[customTheme.secondaryColor]
    };
  }

  return darkTheme ? colorMap.darkTheme : colorMap.lightTheme;
}

function ContentLoaderWrapper({
  height = 140,
  width,
  speed = 1.5,
  darkTheme,
  children,
  customTheme,
  ...props
}) {
  const { primaryColor, secondaryColor } = getTheme(customTheme, { darkTheme });

  return (
    <ContentLoader
      height={height}
      width={width}
      speed={speed}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      {...props}>

      {children}
    </ContentLoader>);

}

export default memo(ContentLoaderWrapper);